import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostBinding, Inject, ViewChild, OnInit } from '@angular/core';
import { MatDrawerMode, MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ProgressBarComponent } from '../../../../../shared/progress/components/progress-bar/progress-bar.component';
import { SidenavComponent } from '../../components/sidenav/sidenav.component';
import { HeaderComponent } from '../../components/header/header.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    imports: [ProgressBarComponent, MatSidenavContainer, MatSidenav, SidenavComponent, MatSidenavContent, HeaderComponent, RouterOutlet]
})
export class MainLayoutComponent implements AfterViewInit, OnInit {
  @ViewChild('mainContainer') mainContainer!: ElementRef;
  opened = true;
  theme = 'light';
  over: MatDrawerMode = 'side' as MatDrawerMode;

  constructor(@Inject(DOCUMENT) private document: Document, private deviceService: DeviceDetectorService,) {
  }

  ngAfterViewInit(): void {
    
  }

  ngOnInit(): void {
    this.handleNavigation();
  }

  handleNavigation() {
    if (this.deviceService.isDesktop()) {
      this.over = 'side';
    }
    else {
      this.opened = false;
      this.over = 'over';
    }
  }

  @HostBinding('class.dark') get themeDark() {
    return this.theme === 'dark';
  }

  toggleSidenav(sidenav: MatSidenav) {
    sidenav.toggle();
  }
}
